const positiveNumber = value => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const normalizeSport = sport => String(sport || '')
  .trim()
  .toLowerCase()
  .replace(/^(sport|replayer)[-_\s]*/, '')
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ');

const sportLabel = sport => normalizeSport(sport)
  .split(' ')
  .filter(Boolean)
  .map(part => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ');

export const getPlayerAffiliationBenefits = membership => {
  const affiliation = membership && membership.affiliation ? membership.affiliation : membership || {};
  const benefits = [];
  const calendarDays = positiveNumber(
    affiliation.visibilityCalendar !== undefined
      ? affiliation.visibilityCalendar
      : affiliation.visibilityCalendarDays
  );

  if (calendarDays !== null) {
    benefits.push({id: 'calendar', type: 'calendar', days: calendarDays});
  }

  if (affiliation.pricingMode === 'dedicated_field_cost') {
    const sportPricing = Array.isArray(affiliation.sportPricing) ? affiliation.sportPricing : [];
    const dedicatedSports = [];

    sportPricing.forEach(pricing => {
      const sport = sportLabel(pricing.sport);
      const discount = positiveNumber(pricing.normalDiscount);
      const participantRates = Array.isArray(pricing.participantRates) ? pricing.participantRates : [];

      if (sport && discount !== null) {
        benefits.push({
          id: `discount-${normalizeSport(pricing.sport)}`,
          type: 'sport_discount',
          discount,
          sport
        });
      }

      if (sport && participantRates.length > 0) {
        dedicatedSports.push(sport);
      }
    });

    if (dedicatedSports.length > 0) {
      benefits.push({
        id: 'dedicated-rates',
        type: 'dedicated_rates',
        sports: [...new Set(dedicatedSports)].join(', ')
      });
    }
  } else {
    const discount = positiveNumber(
      affiliation.discount !== undefined ? affiliation.discount : membership && membership.discount
    );

    if (discount !== null) {
      benefits.push({id: 'discount', type: 'discount', discount});
    }
  }

  return benefits;
};
